export default __webpack_public_path__ + "adf44ee5bff1e83e00582fc23657eaa3.png";